import {useEffect, useState} from "react";
import Accordion from "react-bootstrap/Accordion";
export const Cod = () => {

    const [orders, setOrders] = useState([{}])
    const [timeLastUpdated, setTimeLastUpdated] = useState('')
    const getStringDateUTC = stringDate => {
        const date = new Date(stringDate);
        const h = date.getUTCHours()
        const hh = h <= 9 ? '0' + h : h;
        const m = date.getUTCMinutes()
        const mm = m <= 9 ? '0' + m : m;
        const s = date.getUTCSeconds()
        const ss = s <= 9 ? '0' + s : s;
        const year = date.getUTCFullYear()
        let month = date.getUTCMonth() + 1
        month = month <= 9 ? '0' + month : month;
        let day = date.getUTCDate()
        day = day <= 9 ? '0' + day : day;
        return  year + "-" + month + "-" + day + " " + hh + ":" + mm + ":" + ss
    }


    //*** This code is copyright 2002-2016 by Gavin Kistner, !@phrogz.net
    //*** It is covered under the license viewable at http://phrogz.net/JS/_ReuseLicense.txt
    Date.prototype.customFormat = function(formatString){
        var YYYY,YY,MMMM,MMM,MM,M,DDDD,DDD,DD,D,hhhh,hhh,hh,h,mm,m,ss,s,ampm,AMPM,dMod,th;
        YY = ((YYYY=this.getFullYear())+"").slice(-2);
        MM = (M=this.getMonth()+1)<10?('0'+M):M;
        MMM = (MMMM=["January","February","March","April","May","June","July","August","September","October","November","December"][M-1]).substring(0,3);
        DD = (D=this.getDate())<10?('0'+D):D;
        DDD = (DDDD=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"][this.getDay()]).substring(0,3);
        th=(D>=10&&D<=20)?'th':((dMod=D%10)==1)?'st':(dMod==2)?'nd':(dMod==3)?'rd':'th';
        formatString = formatString.replace("#YYYY#",YYYY).replace("#YY#",YY).replace("#MMMM#",MMMM).replace("#MMM#",MMM).replace("#MM#",MM).replace("#M#",M).replace("#DDDD#",DDDD).replace("#DDD#",DDD).replace("#DD#",DD).replace("#D#",D).replace("#th#",th);
        h=(hhh=this.getHours());
        if (h==0) h=24;
        if (h>12) h-=12;
        hh = h<10?('0'+h):h;
        hhhh = hhh<10?('0'+hhh):hhh;
        AMPM=(ampm=hhh<12?'am':'pm').toUpperCase();
        mm=(m=this.getMinutes())<10?('0'+m):m;
        ss=(s=this.getSeconds())<10?('0'+s):s;
        return formatString.replace("#hhhh#",hhhh).replace("#hhh#",hhh).replace("#hh#",hh).replace("#h#",h).replace("#mm#",mm).replace("#m#",m).replace("#ss#",ss).replace("#s#",s).replace("#ampm#",ampm).replace("#AMPM#",AMPM);
    };

    function getLastMonth(date_today = new Date()) {
        // const dayMonthAgo = new Date(date_today.getFullYear(), date_today.getMonth() - 1, date_today.getDay());
        const dayMonthAgo = new Date(new Date().setDate(date_today.getDate() - 30));
        const getStartYear = dayMonthAgo.toLocaleString("default", { year: "numeric" });
        const getStartMonth = dayMonthAgo.toLocaleString("default", { month: "2-digit" });
        const getStartDay = dayMonthAgo.toLocaleString("default", { day: "2-digit" });
        const getStartTime = "00:00:00"
        let startDateFormat = getStartYear + "-" + getStartMonth + "-" + getStartDay + " " + getStartTime;
        const startDateUTCFormatted = getStringDateUTC(startDateFormat)

        const lastDay = date_today;
        const getEndYear = lastDay.toLocaleString("default", { year: "numeric" });
        const getEndMonth = lastDay.toLocaleString("default", { month: "2-digit" });
        const getEndDay = lastDay.toLocaleString("default", { day: "2-digit" });
        const getEndTime = "23:59:59"
        const endDateFormat = getEndYear + "-" + getEndMonth + "-" + getEndDay + " " + getEndTime;
        const endDateUTCFormatted = getStringDateUTC(endDateFormat)
        const filter = encodeURIComponent("filter[created_between]") + "=" + encodeURIComponent(startDateUTCFormatted + ", " + endDateUTCFormatted)
        return filter;
    }

    const limit = "limit=50"
    const sort = "sort=id"
    const filterLM = getLastMonth()
    const includes = "include=" + encodeURIComponent("manager, status, payments, products.offer, tags, shipping.deliveryService")

    const filterPaymentStatus = encodeURIComponent("filter[payment_status]") + "=" + encodeURIComponent("part_paid")
    const filterStatusId = encodeURIComponent("filter[status_id]") + "=" + encodeURIComponent(1 + ", " + 6  + ", " + 8 + ", " + 9 + ", " + 11 + ", " + 22) //1,6,8,9,11,22,12,30,31
    const parameters = [limit, sort, filterLM, filterStatusId, filterPaymentStatus, includes].join("&")

    const getLocaleDate = (utcDate) => {
        let localeDate = new Date(utcDate);
        const getLocaleDateYear = localeDate.toLocaleString("default", { year: "numeric" });
        const getLocaleDateMonth = localeDate.toLocaleString("default", { month: "2-digit" });
        const getLocaleDateDay = localeDate.toLocaleString("default", { day: "2-digit" });
        const result = getLocaleDateDay + "-" + getLocaleDateMonth + "-" + getLocaleDateYear;
        return result
    }

    useEffect(() => {
        const fetchData = (parameters) => {
            console.log("> start fetchData")
            fetch(`/api/orders?${parameters}`).then(response => {
                if (!response.ok) {
                    console.error(`Помилка завантаження ${response.status}`)
                    if (response.status === 500) {
                        alert("Занадто часто, спробуйте пізніше")
                        throw new Error('Something went wrong.');
                    }
                }
                return  response.json()
            }).then(data => {
                setOrders(data)
            }).catch(function(error) {
                console.log('Request failed', error);
            });
        }

        fetchData(parameters)
        const now = new Date();
        var myString = now.customFormat("#hhh#:#mm#:#ss#");
        setTimeLastUpdated(myString)
    }, []);

    const filterByStatus = order => {
        if(Object.keys(order).length !== 0) {
            return order.status.group_id === 1 || order.status.group_id === 3 || order.status.group_id === 4 || order.status.group_id === 5
        }
    }
    const filterByDeliveryId = order => {
        if(Object.keys(order).length !== 0) {
            return order.shipping.delivery_service_id === 6
        }
    }
    const filterByGrandTotal = order => {
        if(Object.keys(order).length !== 0) {
            return order.grand_total > 0
        }
    }
    const filterByPaymentsLenght = order => {
        if(Object.keys(order).length !== 0) {
            return order.payments.length > 1
        }
    }

    const filterByTags = order => {
        const isNoWholesale = (currentValue) => currentValue.id !== 4;
        if(Object.keys(order).length !== 0) {
            return order.tags.every(isNoWholesale)
        }
    }

    let filteredOrders = orders.filter(filterByTags).filter(filterByPaymentsLenght).filter(filterByGrandTotal)

    const arrCOD = filteredOrders.map(order => {
        return order.payments[order.payments.length - 1].amount
    })
    let sumCOD = 0;
    if (arrCOD.length !== 0) sumCOD = arrCOD.reduce((prev, current) => prev + current)


    console.log("filteredOrders:", filteredOrders)

    let arrDeliveryServices = filteredOrders.reduce((a, c) => {
        const deliveryServiceId = c.shipping?.delivery_service_id ?? "unknown";
        let idx = a.findIndex((e) => (e[0].shipping?.delivery_service_id ?? "unknown") === deliveryServiceId);
        if (idx !== -1) a[idx].push(c);
        else a.push([c]);
        return a;
    }, []);

    console.log("arrDeliveryServices:", arrDeliveryServices)

    return (<>
        <header className="header-orders">
            <div className="section-controls">
                <p>Updated at <strong>{timeLastUpdated}</strong></p>
            </div>
        </header>
        <main>
            <div className="container mt-3 px-0">
                <h5 className="mb-4">
                    Загальна сума наложених платежів по всім ФОПам: <strong>{sumCOD.toLocaleString()} грн.</strong>
                </h5>
                <section className="section-cod">
                    <Accordion defaultActiveKey={'0'} className="lava-accordion">
                    {arrDeliveryServices.map((service, s) => {
                        let nameService = ""
                        let sumCOD = 0;
                        if (service.length !== 0) {
                            nameService = service[0].shipping?.delivery_service?.name || "Служба доставки не вказана"
                            const arrCOD = service.map(order => {
                                return order.payments[order.payments.length - 1].amount
                            })

                            if (arrCOD.length !== 0) sumCOD = arrCOD.reduce((prev, current) => {
                                return prev + current
                            })
                        }

                        return <Accordion.Item key={s} eventKey={s}>
                                <Accordion.Header style={{ fontSize: "20px" }}>{nameService + ": "}<span> Замовлень <strong style={{ fontSize: "21px" }}>{service.length}</strong> шт на сумму накладених платежів:</span><strong style={{ fontSize: "21px" }}>{sumCOD}</strong> грн.</Accordion.Header>
                                <Accordion.Body>
                                    <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th style={{ textAlign: "center"}}>Замовлення</th>
                                            <th style={{ textAlign: "center"}}>ТТН</th>
                                            <th style={{ textAlign: "center"}}>Предоплата</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {service.map((order, o) => {
                                        return <tr key={o}><td>{getLocaleDate(order.created_at)}</td><td>{order.id}</td><td>{order.shipping?.tracking_code || "—"}</td><td>{order.payments_total}</td></tr>
                                    })}
                                    </tbody>
                                    </table>
                                </Accordion.Body>
                            </Accordion.Item>
                    })}
                    </Accordion>
                </section>
            </div>
        </main></>
    );
}